import { Card, Row, Col } from 'antd'
import * as viewTypes from './ViewTypes'

export default ({ setViewType }) ->
  <Row data-testid="view-type-choice" gutter={[48, 32]} justify="center">
    <Col style={{ textAlign: 'center' }} span={24}>
      <h1>This will be a...</h1>
    </Col>
    {
      _.map(viewTypes, (viewType, key) ->
        <Col key={key} className="viewtype-col">
          <Card
            hoverable
            data-testid="view-type-choice-#{key}"
            onClick={-> setViewType(viewType)}
            cover={
              <Row justify="center">
                { viewType.icon }
              </Row>
            }
          >
            <Card.Meta
              title={viewType.title}
              description={viewType.description}
            />
          </Card>
        </Col>
      )
    }
  </Row>
